// LegacyDocs.js
import React from 'react';
// import './LegacyDocs.css'; // (Optional) If additional styling is desired

function LegacyDocs() {
  return (
    <div className="doc-container">
      <header className="doc-header">
        <h1>Legacy Documentation</h1>
      </header>
      <section className="doc-section">
        <p>
          Welcome to the legacy documentation. This section contain older references, historical context for this project.
        </p>
          <p>
              <a href="/legacy-docs/v1">Legacy Docs (v1)</a>
          </p>


          {/* Add any additional sections, tables, or references as needed */}
      </section>
    </div>
  );
}

export default LegacyDocs;